/**
 * @generated SignedSource<<597c692c34a1b12b98c11aec088025ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetEmployeeScheduleShiftsEmployee_employee$data = {
  readonly id: string;
  readonly shifts: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeScheduleShiftBar">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeScheduleShiftsEmployeeNamePanel_employee">;
  readonly " $fragmentType": "WidgetEmployeeScheduleShiftsEmployee_employee";
};
export type WidgetEmployeeScheduleShiftsEmployee_employee$key = {
  readonly " $data"?: WidgetEmployeeScheduleShiftsEmployee_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeScheduleShiftsEmployee_employee">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetEmployeeScheduleShiftsEmployee_employee",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetEmployeeScheduleShiftsEmployeeNamePanel_employee"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeShift",
      "kind": "LinkedField",
      "name": "shifts",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetEmployeeScheduleShiftBar"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Employee",
  "abstractKey": null
};
})();

(node as any).hash = "ecd55f89e54533f5e94a34e9f7f4e180";

export default node;
